import { Page } from "../layout/Page";

export const NotFound: React.FC = () => <Page><h1>Not Found</h1></Page>;